module.exports = __webpack_public_path__ + "static/media/check.24db1203.jpg";